import React from "react";
import { MapContainer, TileLayer, Marker, Circle } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color) =>
  L.divIcon({
    className: "",
    html: `<div style="width:18px;height:18px;border-radius:50%;background:${color};border:3px solid #0A1224;box-shadow:0 0 0 4px ${color}44"></div>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });

export function LocationMap({ lat, lng, radiusKm = 0, color = "#D9A441", height = "12rem" }) {
  if (lat == null || lng == null) return null;
  return (
    <div className="overflow-hidden rounded-2xl border border-cardline" style={{ height }} data-testid="location-map">
      <MapContainer center={[lat, lng]} zoom={12} scrollWheelZoom={false} dragging={true}
        style={{ height: "100%", width: "100%", background: "#0A1224" }} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" className="lc-map-tiles" />
        {radiusKm > 0 && (
          <Circle center={[lat, lng]} radius={radiusKm * 1000}
            pathOptions={{ color, fillColor: color, fillOpacity: 0.1, weight: 1 }} />
        )}
        <Marker position={[lat, lng]} icon={pin(color)} />
      </MapContainer>
    </div>
  );
}
